/**
 * Obtiene el header de autorización con el token JWT
 * Para usar en las peticiones API que requieren autenticación
 */
export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { Authorization: 'Bearer ' + user.token };
  } else {
    return {};
  }
}
